module.exports = __webpack_public_path__ + "static/media/poloImage.c32df470.jpeg";